








import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class UiScrollableComponent extends Vue {
  @Prop({
    default: false
  })
  public mobileOnly: boolean;
}
